import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroBookingBanner from "./sections/HeroBookingBanner";
import Bookingform from "./sections/Bookingform";
import ServiceGrid from "./sections/ServiceGrid";
import ReliabilityInfo from "./sections/ReliabilityInfo";
import TabbedBooking from "./sections/TabbedBooking";
import Services from "./sections/Services";
import Servicesgrid from "./sections/Servicesgrid";
import FleetCarousel from "./sections/FleetCarousel";
import ServicePhilosophyBanner from "./sections/ServicePhilosophyBanner";
import WhyChooseAutoRide from "./sections/WhyChooseAutoRide";
import ClientReviews from "./sections/ClientReviews";
import Testimonials from "./sections/Testimonials";
import Booking from "./sections/Booking";
import Reservation from "./sections/Reservation";
import FinalConversionCTA from "./sections/FinalConversionCTA";
import Footer from "@/reusable_sections/Footer";
import CompanyOverviewSEO from "./sections/CompanyOverviewSEO";
import TrustBadges from "./sections/TrustBadges";
import GlobalNetwork from "./sections/GlobalNetwork";
export default function HomePage() {
  return <div>
      <Header />
      <HeroBookingBanner />
      <Bookingform />
      <ServiceGrid />
      <ReliabilityInfo />
      <TabbedBooking />
      <Services />
      <Servicesgrid />
      <FleetCarousel />
      <ServicePhilosophyBanner />
      <CompanyOverviewSEO />
      <TrustBadges />
      <WhyChooseAutoRide />
      <ClientReviews />
      <Testimonials />
      <Booking />
      <Reservation />
      <FinalConversionCTA />
      <GlobalNetwork />
      <Footer />
    </div>;
}